<template>
  <div class="row">
    <div class="login">
      <div class="col-12">
        <div class="note">
          <p>Để tiếp tục vui lòng nhập mã xác thực OTP được gửi cho bạn qua số điện thoại <b>098765421</b></p>
        </div>
        <div class="pin_otp">
          <pay-password 
            v-model="otp" 
            :length="6"/>
        </div>
        <center><p
          class="text-success mt-4"
          @click="verifyOTP">Verify OTP</p></center>
        <center v-if="is_expired"><p
          class="text-success mt-4"
          @click="getOTP()">Gửi lại mã OTP</p></center>
        <center>
          <countdown 
            :time="120000" 
            @end="handleCountdownEnd">
            <template slot-scope="props">OTP hết hạn trong：{{ props.seconds }} giây.</template>
          </countdown>
        </center>
      </div>
    </div>
  </div>

</template>

<script>
  import payPassword from "vue-pay-password";
  import rf from '../../communicate/RequestFactory';
  import "vue-pay-password/dist/vue-pay-password.css";
  import {errorToaster, infoToaster} from '../../services/ErrorHandler'
  import Vue from 'vue';
  import VueCountdown from '@chenfengyuan/vue-countdown';

  Vue.component('countdown', VueCountdown);
  Vue.component('pay-password', payPassword);

  export default {
    name: "OtpVerify",
    comments: {
      payPassword,
      VueCountdown
    },
    // eslint-disable-next-line vue/require-prop-types
    props: ['phone'],
    data() {
      return {
        otp: '',
        is_expired: false
      }
    },
    methods: {
      verifyOTP() {
        const data = {
          phone: this.phone,
          otp: this.otp
        }
        rf.getRequest("OtpRequest").verifyOTP(data).then((res) => {
          if (res.status === 200) {

          } else {
            infoToaster("Cố vấn phong thủy", res.message);
          }
        }).catch(err => {
          errorToaster("Cố vấn phong thủy", "Xảy ta lỗi két nối");
        })
      },

      getOTP() {
        const data = {
          phone: this.phone
        }
        rf.getRequest("OtpRequest").getOTP(data).then((res) => {
          if (res.status === 200) {

          } else {
            this.infoToaster("Cố vấn phong thủy", res.message);
          }
        }).catch(err => {
          this.errorToaster("Cố vấn phong thủy", "Xảy ta lỗi két nối");
        })
      },

      handleCountdownEnd() {
        this.is_expired = true;
      }
    }
  }
</script>

<style scoped>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

  .pin_otp {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/OtpVerify.vue